<figure>
  @if (dataSignal().img && dataSignal().img !== null) { @if(dataSignal().isVideo) {
  <a
    class="flex cursor-pointer"
    (click)="onClickVideoLinkUrl(dataSignal().link_url)"
    (keydown)="onClickVideoLinkUrl(dataSignal().link_url)"
    tabindex="0"
  >
    <img
      [src]="replaceBucket.replaceBucket(dataSignal().img)"
      [alt]="dataSignal().title"
      [title]="dataSignal().title"
      width="800"
      height="468"
      loading="lazy"
      class="item-image"
    />
  </a>
  } @else {
  <img
    [src]="replaceBucket.replaceBucket(dataSignal().img)"
    [alt]="dataSignal().title"
    [title]="dataSignal().title"
    loading="lazy"
    class="item-image"
  />
  } } @else {
  <div class="item-image"></div>
  }
  <figcaption>
    @switch (headingLevel) { @case ('h3') {
    <h3 class="font-size-22 font-weight-semibold line-clamp-2">{{ dataSignal().title }}</h3>
    } @default {
    <h2 class="font-size-22 font-weight-semibold line-clamp-2">{{ dataSignal().title }}</h2>
    } }
    <p class="font-size-16 font-weight-regular line-clamp-4">{{ dataSignal().excerpt }}</p>
  </figcaption>
</figure>
